import { useStyles } from '@team-griffin/stylr';
import { Alignment } from 'domain/constants/alignment';

import { CellProps } from './Cell';

export default ({ cell }: { cell: CellProps }) =>
  useStyles(
    {
      default: {
        root: {
          textAlign: 'left',
        },
      },
      centered: {
        root: {
          textAlign: 'center',
        },
      },
    },
    {
      centered: cell.layout?.alignment === Alignment.CENTER,
    },
  );
